import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/quiz/psico.svg'
import _imports_1 from '@/assets/quiz/arrow.svg'


const _withScopeId = n => (_pushScopeId("data-v-50e95fc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "quiz-component__image" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_2 = { class: "quiz-component__data" }
const _hoisted_3 = { class: "quiz-component__data-title" }
const _hoisted_4 = { class: "quiz-component__data-type" }
const _hoisted_5 = { class: "quiz-component__data-type-topic" }
const _hoisted_6 = { class: "quiz-component__data-type-number" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "quiz-component__icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["quiz-component", {'entry-left' : _ctx.startComponent}]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goQuiz && _ctx.goQuiz(...args)))
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.quiz.name), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.quiz.type) + " -", 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.quiz.number) + " Questions", 1)
      ])
    ]),
    _hoisted_7
  ], 2))
}